import type { JsxElement } from "@/utils/jsx/jsxElementTypes";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Tab = "Components" | "Icons";

interface AssetsPanelState {
  // Search state
  searchVal: string;

  // Tab state
  activeTab: Tab;

  // Accordion state
  searchAccordionValues: string[];

  // Component state
  variantSelected: any | null;
  detailedAsset: JsxElement | null;
  selectedAsset: JsxElement | null;

  // Actions
  setSearchVal: (value: string) => void;
  setActiveTab: (value: Tab) => void;
  setSearchAccordionValues: (values: string[]) => void;
  setVariantSelected: (value: any | null) => void;
  setDetailedAsset: (asset: JsxElement | null) => void;
  setSelectedAsset: (asset: JsxElement | null) => void;
}

export const useAssetsPanelStore = create<AssetsPanelState>()(
  persist(
    (set) => ({
      // Initial state
      searchVal: "",
      activeTab: "Components",
      searchAccordionValues: [],
      variantSelected: null,
      detailedAsset: null,
      selectedAsset: null,

      // Actions
      setSearchVal: (value) => set({ searchVal: value }),
      setActiveTab: (value) =>
        set({ activeTab: value, selectedAsset: null, detailedAsset: null }),
      setSearchAccordionValues: (values) =>
        set({ searchAccordionValues: values }),
      setVariantSelected: (value) => set({ variantSelected: value }),
      setDetailedAsset: (asset) => set({ detailedAsset: asset }),
      setSelectedAsset: (asset) => set({ selectedAsset: asset }),
    }),
    {
      name: "assets-panel-storage",
      // Migration: handle existing users who had "Storybook" tab selected
      migrate: (persistedState: any, version: number) => {
        if (persistedState?.activeTab === "Storybook") {
          persistedState.activeTab = "Components";
        }
        return persistedState;
      },
      version: 1, // Increment version to trigger migration
    },
  ),
);
